import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as wConsts from "../consts/website-consts";
import NotFound from "../components/notfound";
import Masonry from 'react-masonry-component';
import SideBanners from "../components/sidebanners";
import {Link} from "react-router-dom"
import Pager from "../components/pager"
import LinkButtons from "../components/linkbuttons";

class Home extends Component {

  constructor(props) {
    super(props);
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "home" });
  }
  componentDidMount() {
  }
  componentDidUpdate() {

  }
  zeroPad(tInt) {
    if(tInt<=9) {
      return "0" + tInt;
    }
    return tInt+"";
  }
  getTranslation(key, def="") {
    return wActs.isNullOrUndefined(this.props.WebPage.Translations[key]) ? def : this.props.WebPage.Translations[key];
  }


  slugStr(str) {
    str = wActs.replaceAll(" ","-",str);
    str = str.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ");
    return str;
  }
  render() {
    if(this.props.WebPage.PageLoaded && this.props.WebPage.Page.Name === "404") {
      return <NotFound />;
    }
    let cats = [];
    if(this.props.Categories.Loaded && this.props.Categories.ApiResult.Code == 200) {
      cats = this.props.Categories.ApiResult.Result;
    }
    let totalF = 0;

    if(this.props.FeaturedLinks.Loaded) {
      try {
        totalF = this.props.FeaturedLinks.ApiResult.Context.TotalCount;
      } catch(ex) {}
    }

    let mt = {marginTop: "50px"};

    let sPromo = true;

    return (
      <div className="container" style={{marginTop: "50px"}}>
        <div className="row">
          <div className="col_80">

            {/*Featured Links*/}
            <div className="section top-results">
              <div className="cell x12">
                <div className="bar">
                  <div className="titletext"><strong>{this.getTranslation("page.topresults")}</strong> ({totalF})</div>
                </div>
              </div>
              <div className="clear"></div>
              <div className="boxes">
                {!this.props.FeaturedLinks.Loaded &&
                <div className="cell x12" style={{display: "flex", justifyContent: "center"}}><img src="/imgs/loader.gif" style={{margin: "10px auto"}} alt={"Loading"}/></div>
                }
                {this.props.FeaturedLinks.Loaded &&
                  <React.Fragment>
                    {this.props.FeaturedLinks.ApiResult.Result.map((v,i) => {
                      let pge = this.props.FeaturedLinks.ApiResult.Context.Page;
                      let idx = i+1;
                      if(pge>1) {
                        idx += ((pge-1) * 8);
                      }
                      let url = v.TargetUrl; //Go Right To Link, _blank
                      if(v.Blog) { //No Page, But Blog
                        let uri = new URL(v.Blog.Url);
                        url = uri.pathname + (uri.search.length>0 ? uri.search : "");
                      }
                      if(v.Page) { //Page Always Overides Last ...
                        url = wActs.getCultPath(this.props.WebPage, `/${v.Page.Slug}-${v.Id}`);
                      }

                      let inBox = (
                        <div className="box">
                          <div className="title">
                            <h3 style={{overflow:"hidden", height: "25px"}}>{v.Name}</h3>
                            <p style={{overflow:"hidden", height: "55px"}}>{v.Title}</p>
                          </div>
                          <img src={v.PreviewImageUrl.replace("preview","300x300")} alt={v.AltText}/>
                        </div>
                      );

                      if(url.startsWith("http")) {
                        return (<a href={url} title={v.Title} target={"_blank"} key={"featured-" + i} className="cell x3" style={{cursor: "pointer"}}>{inBox}</a>);
                      } else {
                        return (<Link title={v.Title} to={url} key={"featured-" + i} className="cell x3" style={{cursor: "pointer"}}>{inBox}</Link>);
                      }
                    })}
                  </React.Fragment>
                }
                <div className="clear"></div>
                {(totalF>0 && this.props.FeaturedLinks.ApiResult.Context.TotalPages>1) &&
                  <Pager TotalPages={this.props.FeaturedLinks.ApiResult.Context.TotalPages} Page={this.props.FeaturedLinks.ApiResult.Context.Page} ShowPages={3} Count={this.props.FeaturedLinks.ApiResult.Context.TotalCount}/>
                }
              </div>
            </div>

            {sPromo && <LinkButtons BannersInc={this.props.BannersInc} BannersLoader={this.props.BannersLoader} Zone={"promo-button-88x32"} /> }

            {/*Category Links*/}

            <div className="section top-categories">
              <div className="cell x12">
                <div className="bar">
                  <div className="titletext"><strong>{this.getTranslation("page.topcategories")}</strong> ({cats.length})</div>
                </div>
              </div>
              <div className="clear"></div>
              <div className="categories">
                <div className="cell x12">
                  <Masonry options={{originLeft: true}}>
                      {cats && cats.map((v,i) => {
                        return (
                          <div className="grid-item" key={"grid-item-catlinks-" + i}>
                          <div className="category">
                            <div className="title">
                              {wActs.isNullOrEmpty(v.Url) &&
                                <h3>{v.Name}</h3>
                              }
                              {!wActs.isNullOrEmpty(v.Url) &&
                              <Link to={new URL(v.Url).pathname}><h3>{v.Name}</h3></Link>
                              }
                            </div>
                            {!wActs.isNullOrUndefined(v.Links) &&
                            <ul>
                              {v.Links.map((l,li)=>{

                                let url = l.TargetUrl;
                                let lint = false;

                                if(!wActs.isNullOrUndefined(l.Page)) {
                                  let path = new URL(l.Page.Url).pathname;
                                  url = wActs.getCultPath(this.props.WebPage,wActs.stripCulturePath(path)); lint = true;
                                }
                                let cint = false;
                                if(v.Slug == "popular-countries") {
                                  let path = new URL(l.TargetUrl).pathname;
                                  url = path; cint = true;
                                }
                                let ctint=false;
                                if(v.Slug == "popular-cities") {
                                  let path = new URL(l.TargetUrl).pathname;
                                  url = path; ctint=true;
                                }

                                return (
                                  <li key={"catlink-"+i+"-"+li}>
                                    {this.zeroPad(li+1)}.
                                    {(!lint && !cint && !ctint) &&
                                      <a href={url} title={l.Title} className="country-select" target={"_blank"} style={{maxWidth: "80%", overflow: "hidden", maxHeight: "25px", whiteSpace: "nowrap"}}>&nbsp;<img src={wActs.isNullOrEmpty(l.IconUrl)  ? "/imgs/globe.png" : l.IconUrl} style={{width: "16px",height: "16px"}} alt={l.Name}/><span>{l.Name}</span></a>
                                    }
                                    {lint &&
                                      <Link to={url} title={l.Title} className="country-select" style={{maxWidth: "80%", overflow: "hidden", maxHeight: "25px", whiteSpace: "nowrap"}}>&nbsp;<img src={wActs.isNullOrEmpty(l.IconUrl)  ? "/imgs/globe.png" : l.IconUrl} style={{width: "16px",height: "16px"}} alt={l.Name}/><span>{l.Name}</span></Link>
                                    }
                                    {cint &&
                                      <Link to={url} title={l.Title} className="country-select" style={{ background: "#fff", boxShadow: "none", width: "80%", overflow: "hidden", maxHeight: "25px", whiteSpace: "nowrap"}}>&nbsp;<img src={wActs.countryFlag(l.Code)} alt={l.Name} style={{width: "16px", height: "16px", verticalAlign: "text-top", borderRadius: "16px", boxShadow: "#000 2px 2px 2px"}}/><span style={{marginLeft: "4px"}}>{l.Name}</span></Link>
                                    }
                                    {ctint &&
                                    <Link to={url} title={l.Title} className="country-select" style={{ background: "#fff", boxShadow: "none", width: "80%", overflow: "hidden", maxHeight: "25px", whiteSpace: "nowrap"}}>&nbsp;<span><i className="fa fa-map-marker-alt" style={{color: "red",marginRight:"6px"}}></i>{l.Name}</span></Link>
                                    }

                                    <div className="infos">
                                      {lint &&
                                        <React.Fragment>
                                          <a href={url} title={l.Title}><i className="fas fa-search-plus"></i></a>&nbsp;
                                          <a href={l.TargetUrl} title={l.Title} target={"_blank"}><i className="fas fa-link"></i></a>
                                        </React.Fragment>
                                      }
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                            }
                          </div>
                          </div>
                        );
                      })}
                  </Masonry>
                  <div className="clear"></div>
                </div>
              </div>
            </div>


          </div>
          <SideBanners BannersLoader={this.props.BannersLoader} count={5} max={2}/>
        </div>
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    SelectedLocal: state.Website.Settings.SelectedLocal,
    WebPage: state.Website,
    FeaturedLinks: state.Links.FeaturedLinks,
    Categories: state.Links.Categories,
    BannersLoader: state.Ads.BannersLoader,
    BannersInc: state.Ads.BannersInc
  };
};

export default connect(mapStateToProps)(Home);
